import React from 'react';

import CommonSelect, { CommonSelectProps } from './CommonSelect';
import ServiceSelect from './ServiceSelect';
import { FEATURE_FLAGS } from '@/constants/featureFlags';
import Service from '@/lib/App';

const BackendSelect = ({
  multiple,
  placeholder = `Please select backend${multiple ? 's' : ''}`,
  ...props
}: Omit<CommonSelectProps, 'values' | 'idKey' | 'onSearch'>) => {
  const includeHelixServices =
    Service.cache!.isFeatureFlagOn(FEATURE_FLAGS.SERVICE_AUTHZ) &&
    Service.cache!.isFeatureFlagOn(FEATURE_FLAGS.INCLUDE_HELIX_SERVICES);

  if (includeHelixServices) {
    return <ServiceSelect {...{ placeholder, multiple, ...props }} />;
  }

  const services = Service.cache!.getAllBackendServices();

  return (
    <CommonSelect
      {...{ placeholder, multiple, ...props }}
      values={services}
      idKey="prefix"
      valueFn={({ title, family }) => `${title}${family ? `, ${family}` : ''}`}
    />
  );
};

export default BackendSelect;
